import React from "react";
import styles from "../css/PriorityPill.module.css";

const COLOR_MAP = {
  high: styles.high,
  moderate: styles.medium,
  medium: styles.medium,
  low: styles.low,
};

export default function PriorityPill({ level = "Low" }) {
  const normalized = String(level || "").trim().toLowerCase();
  const cls = COLOR_MAP[normalized] || styles.low;
  const label = level || "Low";
  return <span className={`${styles.pill} ${cls}`}>{label}</span>;
}
